
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_2qdw9_1xihu_93",
  "refresh": "awsui_refresh_2qdw9_1xihu_110",
  "root-no-actions": "awsui_root-no-actions_2qdw9_1xihu_110",
  "root-variant-h2": "awsui_root-variant-h2_2qdw9_1xihu_113",
  "root-variant-h3": "awsui_root-variant-h3_2qdw9_1xihu_113",
  "root-has-description": "awsui_root-has-description_2qdw9_1xihu_113",
  "root-variant-h1": "awsui_root-variant-h1_2qdw9_1xihu_122",
  "main": "awsui_main_2qdw9_1xihu_132",
  "no-wrap": "awsui_no-wrap_2qdw9_1xihu_142",
  "main-variant-h1": "awsui_main-variant-h1_2qdw9_1xihu_148",
  "actions": "awsui_actions_2qdw9_1xihu_156",
  "actions-centered": "awsui_actions-centered_2qdw9_1xihu_161",
  "actions-variant-h1": "awsui_actions-variant-h1_2qdw9_1xihu_164",
  "actions-variant-h2": "awsui_actions-variant-h2_2qdw9_1xihu_167",
  "actions-variant-h3": "awsui_actions-variant-h3_2qdw9_1xihu_170",
  "title": "awsui_title_2qdw9_1xihu_183",
  "title-variant-h1": "awsui_title-variant-h1_2qdw9_1xihu_188",
  "title-variant-h2": "awsui_title-variant-h2_2qdw9_1xihu_195",
  "title-variant-h3": "awsui_title-variant-h3_2qdw9_1xihu_201",
  "virtual-space": "awsui_virtual-space_2qdw9_1xihu_222",
  "info": "awsui_info_2qdw9_1xihu_228",
  "description": "awsui_description_2qdw9_1xihu_232",
  "description-variant-h1": "awsui_description-variant-h1_2qdw9_1xihu_237",
  "description-variant-h2": "awsui_description-variant-h2_2qdw9_1xihu_241",
  "description-variant-h3": "awsui_description-variant-h3_2qdw9_1xihu_248",
  "heading": "awsui_heading_2qdw9_1xihu_257",
  "heading-variant-h1": "awsui_heading-variant-h1_2qdw9_1xihu_266",
  "heading-variant-h2": "awsui_heading-variant-h2_2qdw9_1xihu_271",
  "heading-variant-h3": "awsui_heading-variant-h3_2qdw9_1xihu_276",
  "heading-text": "awsui_heading-text_2qdw9_1xihu_282",
  "heading-text-variant-h1": "awsui_heading-text-variant-h1_2qdw9_1xihu_285",
  "heading-text-variant-h2": "awsui_heading-text-variant-h2_2qdw9_1xihu_293",
  "heading-text-variant-h3": "awsui_heading-text-variant-h3_2qdw9_1xihu_301",
  "counter": "awsui_counter_2qdw9_1xihu_310"
};
  